export default __webpack_public_path__ + "static/provider-usage-widget-light-real-c110e5f98862b43408a6ba9951d51215.jpg";